import { types } from './types';
import firebase from '../firebase/firebase';

const db = firebase.database();

export const sendCompanyNotification = ({ message, title, type, companyId, messageId }) => async dispatch => {
    return new Promise(function(resolve, reject) {
        console.log('SENDING NOTIFICATION');
        dispatch({
            type: types.SEND_COMPANY_NOTIFICATION,
            payload: { message, title, type , isVisible: true}
        });
        // CLOSE DIALOG AFTER SPECIFIED DURATION OR DEFAULT
        setTimeout(()=>{
            var updates = {};
            updates[`/providerCompanies/${companyId}/messageQueue/${messageId}`] = null;
            updates[`/providerCompanies/${companyId}/readMessages/${messageId}`] = {
                message,
                title: title || 'Error',
                type,
                messageId,
                readOn: new Date().getTime()
            };

            db.ref().update(updates, error => {
                if(error){
                    console.log(error);
                } else {
                    console.log('updated message queues succesfully');
                }
            });

            dispatch({
                type: types.HIDE_COMPANY_NOTIFICATION,
                payload: false
            });
        }, 8000);

        resolve(true);
    });
}


// WEBPACK FOOTER //
// ./src/js/actions/company-notifications-actions.js